module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    staticClass: "smart",
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.testResult.id) ? _vm._l((_vm.blocks), function(block, index) {
    return _c('Block', {
      key: index,
      attrs: {
        "title": block.title,
        "description": block.description,
        "id": _vm.id,
        "data": block.data,
        "method": block.method,
        "service": "smart",
        "type": block.key,
        "isOpened": block.key === 'recommendations'
      }
    })
  }) : _c('Warning', [_c('p', [_c('b', [_vm._v("Чтобы увидеть рекомендации «Умного навигатора», необходимо пройти тест-игру!")])]), _c('p', [_vm._v("Эта подборка профессий соответствует тем приоритетам, которые ребенок определил для себя при прохождении тест-игры.")]), _c('p', [_vm._v("В этом разделе мы отображаем самые полезные программы, подобранные для вашего ребёнка по\nрезультатам прохождения им тест-игры. Кроме того, мы показываем профессии, которые могут ему\nподойти, а также публикуем актуальные и интересные статьи, интервью со специалистами и видео,\nкоторые помогут узнать больше об этих профессиях. Для того чтобы ребёнок смог увидеть профессии и\nполезные материалы, рекомендованные именно ему, он должен пройти несложную игру по методике\nдоктора педагогических наук, профессора МГУ Н.С. Пряжникова, самого видного отечественного\nспециалиста в области профессионального самоопределения. Эта тест-игра была разработана им\nспециально для нашего сервиса.")])]), _c('IntalentTest', {
    attrs: {
      "iframeSrc": _vm.iframeSrc
    },
    on: {
      "completed": _vm.onCompleted
    },
    model: {
      value: (_vm.process),
      callback: function($$v) {
        _vm.process = $$v
      },
      expression: "process"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db589acc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/cabinet/components/smart/Smart.vue
// module id = 59f940636362eec52c95
// module chunks = 19